module.exports = __webpack_public_path__ + "img/MobileDisabledFeedbackGood.64d02e4f.png";